import { useBuildStore } from "~/components/build/Show/lib/useBuildStore";

// Re-export useAllJobsQuery from its new location for backwards compatibility
export { useAllJobsQuery } from "~/components/build/Show/lib/queries/allJobs";

/**
 * Get jobs from the build store.
 */
export function useJobs() {
  return useBuildStore((state) => state.jobs);
}
